import React from 'react';
import { format } from 'date-fns';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

import { StartedBulkVerificationRun } from 'api/bitedb/entities/bulkVerificationRun.service';
import { formatCount, validDate } from './bulkVerificationFormat';

/** Step 3: the run is reserved and queued. */
const BulkVerificationStartedStep: React.FC<{
  run: StartedBulkVerificationRun;
}> = ({ run }) => {
  const startedAt = validDate(run.createdAt);
  const facts: Array<[string, string, string]> = [
    ['entities', 'Entities', formatCount(run.total)],
    ['credits', 'Credits reserved', formatCount(run.creditsRequired)],
    [
      'started',
      'Started',
      startedAt ? format(startedAt, 'd MMM yyyy, HH:mm') : '',
    ],
  ];

  return (
    <div className='bdb-bulk-verify-started'>
      <div className='bdb-bulk-verify-started-icon' aria-hidden='true'>
        <VerifiedUserOutlinedIcon />
      </div>
      <h2>Verification is running</h2>
      <p>
        It carries on in the background, even if you close this window or leave
        the page. Progress shows above the entity table for everyone on your
        team.
      </p>
      <dl className='bdb-bulk-verify-facts'>
        {facts.map(([id, label, value]) => (
          <React.Fragment key={id}>
            <dt id={`bdb-bulk-verify-fact-${id}`}>{label}</dt>
            <dd aria-labelledby={`bdb-bulk-verify-fact-${id}`}>{value}</dd>
          </React.Fragment>
        ))}
      </dl>
    </div>
  );
};

export default BulkVerificationStartedStep;
